import { render, staticRenderFns } from "./Contract.vue?vue&type=template&id=2c52acad&scoped=true"
import script from "./Contract.vue?vue&type=script&lang=js"
export * from "./Contract.vue?vue&type=script&lang=js"
import style0 from "./Contract.vue?vue&type=style&index=0&id=2c52acad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c52acad",
  null
  
)

export default component.exports